module.exports = __webpack_public_path__ + "img/straight_line_icon_124.e42d9a95.svg";